import api from "PFCore/api";
import { Id, NotificationGroup, NotificationGroupType } from "PFTypes";
import { PaginatedCollection } from "PFTypes";

export type FetchNotificationsGroupsPayload = {
  groupType: NotificationGroupType;
  categories?: string[];
  excludedCategories?: string[];
  read?: boolean;
  important?: boolean;
  templateKey?: string;
  roleId?: Id;
  engagementId?: Id;
  page?: number;
  perPage?: number;
};

export type FetchNotificationsGroupsResponse = PaginatedCollection<NotificationGroup[]>;

export const fetchNotificationsGroups = ({
  groupType,
  categories,
  excludedCategories,
  read,
  important,
  templateKey,
  roleId,
  engagementId,
  page,
  perPage
}: FetchNotificationsGroupsPayload) =>
  api<FetchNotificationsGroupsResponse>({
    url: "notifications/groups",
    params: {
      groupType,
      categories,
      excludedCategories,
      roleId,
      engagementId,
      page,
      perPage,
      ...(read !== undefined ? { read } : {}),
      ...(important !== undefined ? { important } : {}),
      ...(templateKey ? { templateKey } : {})
    }
  });
